import { ExternalLink, KeyRound, ShieldCheck, Info } from 'lucide-react';

const EBARREAU_URL = 'https://ebarreau2.fr/';
const CNB_HELP_URL =
  'https://assistance.cnb.avocat.fr/hc/fr/articles/360004843660-Acc%C3%A9dez-%C3%A0-e-Barreau';

export function EBarreauPage() {
  function openEBarreau() {
    window.open(EBARREAU_URL, '_blank', 'noopener,noreferrer');
  }

  return (
    <div className="main-container-gdm">
      <div className="mx-auto max-w-3xl rounded-xl border border-neutral-200 bg-white p-6">
        <div className="flex items-start gap-4 mb-5">
          <div className="w-12 h-12 rounded-lg bg-[rgba(4,52,41,0.08)] flex items-center justify-center flex-shrink-0">
            <KeyRound className="w-6 h-6 text-cime-primary" />
          </div>
          <div>
            <h2 className="text-[19px] font-semibold text-cime-text-primary">
              Portail officiel du CNB
            </h2>
            <p className="text-sm text-cime-text-muted mt-1">
              Communication avec les juridictions, dépôts d'actes dématérialisés,
              consultation des dossiers de procédure.
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={openEBarreau}
          className="inline-flex items-center gap-2 bg-cime-primary text-white text-sm font-medium px-4 py-2.5 rounded-full hover:opacity-90 transition"
        >
          <ExternalLink className="w-4 h-4" />
          Ouvrir e-Barreau
        </button>

        <div className="mt-6 pt-5 border-t border-neutral-100 space-y-3 text-sm">
          <div className="flex items-start gap-2 text-cime-text-muted">
            <ShieldCheck className="w-4 h-4 text-cime-accent mt-0.5 flex-shrink-0" />
            <span>
              L'authentification se fait avec votre <strong>Clé Avocat</strong> (certificat
              sur token USB) ou via <strong>e-Dentitas</strong>. CIME ne stocke aucun
              identifiant e-Barreau.
            </span>
          </div>
          <div className="flex items-start gap-2 text-cime-text-muted">
            <Info className="w-4 h-4 text-cime-accent mt-0.5 flex-shrink-0" />
            <span>
              Pour la première connexion ou en cas de problème, consultez la{' '}
              <a
                href={CNB_HELP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="underline hover:text-cime-primary"
              >
                documentation officielle du CNB
              </a>
              .
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
